import "./cardComunidadPractica.css";
const Iconroute = `/wp-content/themes/observatorio-omt-web/assets/icons/`;
import BtnPost from "../../../../shared/btn/btn";

const CardComunidadPractica = (props) => {
  const data = props.data;
  const key = props.key ? props.key : 1;

  const {
    id,
    title,
    slug,
    excerpt,
    link,
    featuredImg,
    access_status,
    moderadores,
  } = data;

  const openModal = () => {
    const url_input = document.querySelector(".forminator-website--field");
    const input_mail = document.querySelector(".form-email-moderator");
    const form_mail = input_mail.querySelector(".forminator-email--field");
    const input_title = document.querySelector(".input-form-title");
    const form_title = input_title.querySelector(".forminator-name--field");
    moderadores.forEach((element) => {
      form_mail.value += `${element},`;
    });
    form_title.value = title;
    if (url_input) {
      url_input.value = link;
    }
  };
  const htmlLang = document.documentElement.lang;
  const baseUrl = link.split(".org")[0] + ".org";
  const urlPath = new URL(link);
  const pathAfterDomain = urlPath.pathname;

  const isLangEnUS = htmlLang === "en-US";

  const finalLink = isLangEnUS
    ? `${baseUrl}/en${pathAfterDomain}`
    : `${baseUrl}${pathAfterDomain}`;

  return (
    <ul className="community-practice" data-layout="list">
      <li id={`post-${id}`} className={`post-${id} communty-practice__content`}>
        <div className="community-item">
          <div className="community-wrap-thumbnail">
            <a
              href={access_status ?? finalLink}
              className="thumbnail-preview"
              alt={`Redirección a la comunidad ${title}`}
            >
              <img
                width="500"
                height="166"
                src={featuredImg}
                className="thumbnail-img"
                alt={title}
                title={title}
                loading="lazy"
              />
            </a>
          </div>
        </div>

        <div className="community-content">
          <a
            href={access_status ?? finalLink}
            className="community-permalink"
            alt={`Redirección a la comunidad ${title}`}
          >
            <h3 className="community-title">{title}</h3>
          </a>

          <div className="community-info">
            <div className="community-excerpt">
              <div
                className="community-excerpt-text"
                dangerouslySetInnerHTML={{ __html: excerpt }}
              />
            </div>

            <div
              onClick={() => {
                openModal();
              }}
            >
              {access_status ? (
                <BtnPost
                  btnLink={finalLink}
                  text={access_status}
                  svgIcon={Iconroute + "arrow-right-white.svg"}
                  btnType={"primary-botton"}
                />
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modalForm"
                >
                  Solicitar unirse
                </button>
              )}
            </div>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default CardComunidadPractica;
